"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var yup = _interopRequireWildcard(require("yup"));

var schema = yup.object().required('reducerDescription is required').typeError('reducerDescription should be an object');

function createReducer(initialState, reducerDescription) {
  schema.validateSync(reducerDescription);
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;

    if (!action.type) {
      console.warn("Handling an action without type: ".concat(JSON.stringify(action)));
    }

    var handler = reducerDescription[action.type];
    return handler && handler(state, action) || state;
  };
}

var _default = createReducer;
exports["default"] = _default;